module.exports = __webpack_public_path__ + "img/discord.bb408e03.svg";